import Block from '../../common.blocks/block'

export default class CheckoutSidebar extends Block {
	static title = 'checkout-sidebar'

	constructor($el) {
		super($el)

		this.buttons = this.$el.findElement('button')
		this.parts = this.$el.findElement('parts')
		this.proceedButton = $('.checkout__button--proceed')

		if (this.buttons) {
			this.buttons.on('click', () => {
				this.parts.toggleClass('checkout-sidebar__parts--hidden')
				this.proceedButton.prop('disabled', function (i, val) {
					return !val
				})
			})
		}
	}
}
